import React, { useContext, useState, useEffect } from "react";
// import { Route, useLocation } from "react-router-dom";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Switch,
  useLocation,
  useNavigate,
} from "react-router-dom";

import { styled, createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import MuiDrawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Link from "@mui/material/Link";
import MenuIcon from "@mui/icons-material/Menu";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import Avatar from "@mui/material/Avatar";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import MainListItems from "./listItems";
import BLimg from "../../assets/images/betterLife.png";
import CreatePage from "../create-request";
import LoginPage from "../Login";
import ApprovalPage from "../approvals";
import LogRequestPage from "../log-request";
import EditRequestPage from "../edit-request";
import ViewRequest from "../view-request";
import UsersPage from "../users";
import MapPage from "../users/mapUsers";
import { AppContext } from "../../context";
import Service from "../../services";
import ProtectedRoute from "../../auth";
import "./index.css";
import AddValidation from "../add-validations";

const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  backgroundColor: "#E5E5E5",
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  "& .MuiDrawer-paper": {
    backgroundColor: "#E5E5E5",
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    boxSizing: "border-box",
    ...(!open && {
      overflowX: "hidden",
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: theme.spacing(7),
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(9),
      },
    }),
  },
}));

const mdTheme = createTheme();

function DashboardContent() {
  useEffect(() => {
    if (sessionStorage.getItem("SSOToken") === null) {
      navigate("/logout")
    }
  }, []);
  const appdata = useContext(AppContext);
  const [isAuth, setIsAuth] = appdata[0];
  const [userInfo, setUserInfo] = appdata[1];

  const bgSignOn = process.env.REACT_APP_BGSIGNONURL_DEV;

  const location = useLocation();
  const navigate = useNavigate();
  let routename = location.pathname.substring(1);
  let routeName = routename.charAt(0).toUpperCase() + routename.slice(1);
  console.log(routeName);
  const [open, setOpen] = useState(true);
  const toggleDrawer = () => {
    setOpen(!open);
  };
  const [anchorEl, setAnchorEl] = useState(null);
  const openNavMenu = Boolean(anchorEl);
  const handleNavMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseNavMenu = () => {
    setAnchorEl(null);
  };

  //LogOut
  const logOut = () => {
    // setIsAuth(false);
    sessionStorage.clear();

    navigate("/logout");
  };
  return (
    <ThemeProvider theme={mdTheme}>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <AppBar position="absolute" open={open}>
          <Toolbar
            sx={{
              pr: "24px", // keep right padding when drawer closed
            }}
          >
            <IconButton
              edge="start"
              aria-label="open drawer"
              onClick={toggleDrawer}
              sx={{
                color: "#000",
                marginRight: "36px",
                ...(open && { display: "none" }),
              }}
            >
              <MenuIcon />
            </IconButton>
            <Typography
              component="h1"
              variant="h6"
              color="#000"
              noWrap
              sx={{ flexGrow: 1 }}
            >
              {/* {routeName} */}
            </Typography>
            <p style={{ color: "#000" }}>
              Welcome,
              {JSON.parse(sessionStorage.getItem("userDetails")).staff_name}
            </p>
            <IconButton
              color="inherit"
              sx={{ marginRight: "15px" }}
              id="demo-positioned-button"
              aria-controls={openNavMenu ? "demo-positioned-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={openNavMenu ? "true" : undefined}
              onClick={handleNavMenu}
            >
              <Avatar>
                <AccountCircleIcon />
              </Avatar>
            </IconButton>
            <Menu
              id="demo-positioned-menu"
              aria-labelledby="demo-positioned-button"
              anchorEl={anchorEl}
              open={openNavMenu}
              onClose={handleCloseNavMenu}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
            >
              <MenuItem onClick={logOut}>Logout</MenuItem>
            </Menu>{" "}
            <img
              src={BLimg}
              alt="better life"
              width="4.5%"
              //   height="50%"
            />
          </Toolbar>
        </AppBar>
        <Drawer variant="permanent" open={open}>
          <Toolbar
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              px: [1],
            }}
          >
            <IconButton onClick={toggleDrawer}>
              <ChevronLeftIcon />
            </IconButton>
          </Toolbar>
          <Divider />
          <List component="nav">
            <MainListItems />
            {/* <Divider sx={{ my: 1 }} />
            {secondaryListItems} */}
          </List>
        </Drawer>
        <Box
          component="main"
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === "light"
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            flexGrow: 1,
            height: "100vh",
            overflowY: "auto",
            overflowX: "hidden",
          }}
        >
          <Toolbar />
          <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
            <Routes>
              <Route path="create" element={<CreatePage />} />
              {/* <Route path="new-request" element={<NewRequest />} /> */}

              <Route path="/log-request" element={<LogRequestPage />} />
              <Route path="/edit-request" element={<EditRequestPage />} />
              <Route path="view-request" element={<ViewRequest />} />
              <Route path="approvals" element={<ApprovalPage />} />
              <Route path="add-validation" element={<AddValidation/>} />
              <Route path="create-users" element={<UsersPage />} />
              <Route path="map-users" element={<MapPage />} />
            </Routes>
          </Container>
        </Box>
      </Box>
    </ThemeProvider>
  );
}

export default function Dashboard() {
  return <DashboardContent />;
}
